import i18next from "i18next";

import { ACHIEVEMENTS } from "../constants/achievement.config";
import {
  AchievementType,
  AchievementUserNotificationData,
  FollowUserNotificationData,
  LeaderboardUserNotificationData,
  UserNotification,
  UserNotificationType,
} from "@onmo/graphql/graphql";

const Leaderboard_Type = {
  GLB_WEEKLY: "global-leaderboard-weekly",
  GLB_MONTHLY: "global-leaderboard-monthly",
};

export const NotificationTypeInTGP = [
  UserNotificationType.FollowedByUser,
  UserNotificationType.AchievementReward,
  UserNotificationType.GlobalLeaderboardEnded,
];

const getAchievementNameByType = (type: AchievementType) => {
  const achievement = ACHIEVEMENTS.find((item) => item.id === type);
  return achievement ? i18next.t(achievement.name) : "Achievement";
};

const getAchievementIconsFromIdAndTier = (id: string, tier: number) => {
  const achievement = ACHIEVEMENTS.find((a) => a.id === id);
  if (!achievement) return null;

  return achievement.icons[tier];
};

const getContent = (notification: UserNotification) => {
  if (!notification) return;
  switch (notification?.type) {
    case UserNotificationType.FollowedByUser:
      return {
        title: "New Follower",
        message: (notification?.data as FollowUserNotificationData)
          ?.followerUser?.username,
      };
    case UserNotificationType.AchievementReward: {
      const achievementName = NotificationMd.getAchievementNameByType(
        (notification.data as AchievementUserNotificationData).type,
      );
      return {
        title: "New Achievement",
        message: achievementName,
      };
    }
    case UserNotificationType.GlobalLeaderboardEnded: {
      const lbData = notification.data as LeaderboardUserNotificationData;
      if (lbData.leaderboardType === Leaderboard_Type.GLB_WEEKLY) {
        return {
          title: "Weekly Leaderboard",
          message: `#${lbData.rank}`,
        };
      } else if (lbData.leaderboardType === Leaderboard_Type.GLB_MONTHLY) {
        return {
          title: "Monthly Leaderboard",
          message: `#${lbData.rank}`,
        };
      }
    }
  }
};

const filterNotificationType = (notification?: UserNotification[]) => {
  if (!notification) return [];

  const res = notification.filter((item) => {
    return NotificationTypeInTGP.includes(item.type);
  });

  return res;
};

export const NotificationMd = {
  getAchievementNameByType,
  getAchievementIconsFromIdAndTier,
  getContent,
  filterNotificationType,
};
